// extracted by mini-css-extract-plugin
module.exports = {"Divider":"Divider-module--Divider--2BP7s","DividerBlue":"Divider-module--Divider--blue--1DYnG"};